import { useMutation, useQueryClient } from '@tanstack/react-query';
import CarePlanService from '@/services/CarePlanService';
import { CARE_PLAN_KEYS } from './keys';
import { scheduleInvalidate } from '@/state/data/_shared/wf-race';

// Async via Tier 4 care_plan_updated → n8n workflow. See _shared/wf-race.ts.
// Optimistic local update lives in the consuming modals (PatientDetail
// `setCarePlan(prev => ({...prev, ...patch}))`); just defer reconciliation.

export function useUpdateCarePlan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      withingsUserId: string | number;
      updates: Record<string, unknown>;
    }) => CarePlanService.updateCarePlan(vars.withingsUserId, vars.updates),
    onSettled: (_d, _e, vars) => {
      scheduleInvalidate(qc, CARE_PLAN_KEYS.byUser(vars.withingsUserId));
      scheduleInvalidate(qc, CARE_PLAN_KEYS.list());
    },
  });
}
